import { useEffect, useRef } from 'react'
import '../../../App.css'
import Container from 'react-bootstrap/Container'
import { Navbar, Nav, NavDropdown } from 'react-bootstrap'
import NavbarTopAdmin from '../../admin/components/navbarTopAdmin'
import { useSearchParams } from 'react-router-dom'
import Notifiche from './notifiche'

function NavbarNotAuth() {
    const [searchParams, setSearchParams] = useSearchParams()
    const bannerCorrente = searchParams.get('banner')
    const navbar = useRef(); const lastScrollY = useRef(0)

    const email = localStorage.getItem('logged')
    const logged = localStorage.getItem('idUser')

    const margineTraTitoli = '15%'
    const pallinaRossa = { width: '.6em', height: '.6em', borderRadius: '50%', backgroundColor: 'red', position: 'absolute', display: 'none' }
    function controlNavbar() {
        if (window.scrollY > lastScrollY.current && window.scrollY > 200) {
            navbar.current.style.top = '-5rem'
        }
        else { navbar.current.style.top = '0' }
        lastScrollY.current = window.scrollY
    }
    function pallinaRossaCheck(e) {
        if (e === true) {
            const x = document.getElementsByClassName('ntfPresent')
            for (let b = 0; b < x.length; b++) {
                x[b].style.display = 'block'
            }
        }
    }

    useEffect(() => {
        if (email !== 'maladmin@admin.it') {
            window.addEventListener('scroll', controlNavbar)
            return () => { window.removeEventListener('scroll', controlNavbar) }
        }
    }, [lastScrollY])

    useEffect(() => {
        if (bannerCorrente) {//cosa fare quando clicco previous page
            document.body.style.overflow = 'hidden'
        } else { document.body.style.overflow = '' }
    }, [bannerCorrente])

    useEffect(() => {
        const isRefresh = window.performance //intercetto il ricaricamneto della pagina (F5)
            ?.getEntriesByType('navigation')
            ?.[0].type === 'reload'
        if (isRefresh && searchParams.has('banner')) {//rimuovo 'banner' quando ricarico la pagina
            searchParams.delete('banner')
            setSearchParams(searchParams, { replace: true })
        }
    }, [])

    return (<>
        {email === 'maladmin@admin.it' && logged ? <NavbarTopAdmin /> :
            <div className='header' ref={navbar} style={{ zIndex: '1', position: 'fixed', top: '0px', left: '0px', right: '0px', transition: '.5s', width: '100%' }}>
                <Navbar expand="lg" collapseOnSelect className="bg-dark" variant={'dark'} sticky="top" >
                    <Container fluid>
                        <Navbar.Brand href="/" style={{ fontFamily: 'sans-serif', marginRight: '12%', marginLeft: '1%', color: 'cornsilk', fontWeight: '600' }}>
                            <img src={require('../image/zona_eventi_icon.jpg')} style={{ borderRadius: '50%', width: '30px', height: '30px' }} alt='' />
                        </Navbar.Brand>

                        <div className='iconChatMobile'>
                            <button style={{ backgroundColor: 'transparent', border: 'none' }} onClick={() => {
                                if (bannerCorrente !== 'notifiche') {
                                    setSearchParams({ banner: 'notifiche' })
                                } else window.history.back()
                            }}>
                                <p style={pallinaRossa} className='ntfPresent'>
                                </p>
                                <img src={require('../../userNotAuth/image/icons8-notifica-50.png')} width={'28em'} alt='' />
                            </button>
                        </div>

                        <Navbar.Toggle aria-controls="navbarScroll" style={{ border: '1px solid white' }}>
                            <img src={require('../image/icons8-menu-50.png')} style={{ width: '30px', height: '35px' }} alt='' />
                        </Navbar.Toggle>

                        {/* --------------------- INIZIO TITOLI --------------------------- */}
                        <Navbar.Collapse id="navbarScroll">
                            <Nav className="me-auto my-2 my-lg-0 navbarMargin" style={{ maxHeight: '100%', width: '40%' }}>

                                <NavDropdown title="Eventi" id="navbarScrollingDropdown" style={{ marginRight: margineTraTitoli }}>
                                    <NavDropdown.Item href="/">Home</NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item href="/cosaFare">Cosa fare</NavDropdown.Item>
                                    {logged &&
                                        <div>
                                            <NavDropdown.Divider />
                                            <NavDropdown.Item href="/myEventiTable">My eventi</NavDropdown.Item>
                                        </div>
                                    }
                                </NavDropdown>

                                <Nav.Link className="text-nowrap" href='/addEvento' id="navbarScrollingDropdown" style={{ marginRight: margineTraTitoli }}>Crea Evento
                                    {/* <NavDropdown.Item href="/addEvento" style={{ marginRight: '5rem' }}>Senza registrazione</NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item href="/login" style={{ marginRight: '5rem' }}>Accedi o registrati</NavDropdown.Item> */}
                                </Nav.Link>

                                <NavDropdown title="Artisti/FoodTruck" style={{ marginRight: margineTraTitoli }}>
                                    <NavDropdown.Item href="/artisti">Artisti</NavDropdown.Item>
                                    <NavDropdown.Item href="/foodTruck">Food Truck</NavDropdown.Item>
                                    {logged &&
                                        <div>
                                            <NavDropdown.Divider />
                                            <NavDropdown.Item href="/profiloArtista">My artista</NavDropdown.Item>
                                        </div>
                                    }
                                </NavDropdown>

                                <Nav.Link href="/fornitori" style={{ marginRight: margineTraTitoli }}>
                                    Fornitori
                                </Nav.Link>

                                <Nav.Link href="/newsletter" style={{ marginRight: margineTraTitoli }}>Food&Travel</Nav.Link>

                                {/* <NavDropdown title="Login" id="navbarScrollingDropdown" style={{ marginRight: margineTraTitoli }}>
                                    <NavDropdown.Item href="/login">Accedi</NavDropdown.Item>
                                    <NavDropdown.Item href="/register">Registrati</NavDropdown.Item>
                                </NavDropdown> */}

                                <div className='iconChatDesktop ms-5'>
                                    <button style={{ backgroundColor: 'transparent', border: 'none' }} onClick={() => {
                                        if (bannerCorrente !== 'notifiche') {
                                            setSearchParams({ banner: 'notifiche' })
                                        } else window.history.back()
                                    }}>
                                        <p style={pallinaRossa} className='ntfPresent'>
                                        </p>
                                        <img src={require('../../userNotAuth/image/icons8-notifica-50.png')} width={'24em'} className='blink' alt='' />
                                    </button>
                                </div>

                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
                <Notifiche
                    flag={bannerCorrente}
                    pallinaRossaCheck={pallinaRossaCheck}
                />
            </div>
        }
    </>)
}
export default NavbarNotAuth